@if (!selectedOfficeIsRecruitment) {
  <div id="dashboardMenu" class="collapse navbar-collapse">
    <ul class="navbar-nav me-auto">
      @for (entry of tabEntries; track $index; let i = $index) {
        <li [id]="entry.id" class="nav-item" [ngClass]="{'active': selectedTab == i}">
            <a class="nav-link" (click)="onSelectTab($event, i)">{{entry.caption}}</a>
        </li>
      }
    </ul>
  </div>
}
